import { tcodeViewApi } from "./Screens/Utils/apis/tCodeViewAPI";

export const LOGIN_SCREEN_CONSTANTS = {
    RIWA_HEADING: "RIWA",
    RIWA_SUBHEADING: "Welcome to your trusted AI companion! ",
    RIWA_SUBHEADING2: "Empowering you with Reliable Insights, Effortless Progress, and Infinite Possibilities.",
    AMNS_USER_BUTTON: "AM/NS India",
    VENDOR_BUTTON: "Vendor",
    DOMAIN_INPUT_PLACEHOLDER: "User ID (ariwa1)",
    PASSWORD_INPUT_PLACEHOLDER: "Password",
    OTP_INPUT_PLACEHOLDER: "OTP",
    FORGOT_PASSWORD: "Forgot Password?",
    LOGIN_BUTTON: "Log In",
    EMAIL_INPUT_PLACEHOLDER: "Please enter your email id",
    VENDOR_EMAIL_INPUT_PLACEHOLDER: "Vendor Code",
    OTP_BUTTON: "Send OTP",
    COMPANY_SIGN_ON_BUTTON: "Company Single Sign On",
    LOGIN_SCREEN_FOOTER: "Developed by AM/NS IT",
    USERNAME_INVALID: "Username should not contain any spaces or special characters.",
    RIWA_CHAT_AI_MESSAGE: "RIWA is not trained on AMNS data. AI generated responses may not be accurate.",
}

export const HOME_SCREEN_CONSTANTS = {
    NEWLY_ADDED: "Newly Added Categories",
    FREQUENTLY_ACCESSED: "Frequently Accessed Categories",
}

export const CHAT_SCREEN_CONSTANTS = {
    NEW_CHAT_BUTTON: "New Chat",
    SEARCH_PLACEHOLDER: "Search",
    FEEDBACK_BUTTON_TOOLTIP: "Feedback",
    HELP_BUTTON_TOOLTIP: "Help",
    HISTORY_SIDEBAR_BUTTON_TOOLTIP: "History",
    HISTORY_SIDEBAR_HEADING: "History",
    HOME_SIDEBAR_HEADING: "Home",
    HOME_SIDEBAR_TOOLTIP: "Home",
    DRAG_DROP_TEXT: "Drag and drop a file here to upload",
    DRAG_DROP_OR: "Or",
    DRAG_DROP_CHOOSE: "Choose a file",
    REMOVE_FILE: "Remove",
    UPLOAD_FILE: "Upload",
    UPLOAD_FILE_FILE_TOO_LARGE: "File too large, maximum file size allowed: 30MB",
    UPLOAD_FILE_RIWA_GPT_FILE_TOO_LARGE: "File too large, maximum file size allowed: 40MB",
    UPLOAD_FILE_FILE_TYPE_NOT_ALLOWED: "File type not allowed, allowed types: png, jpeg, jpg, tif, pdf, xlsx, xls, docx, ppt, pptx, txt, doc, eml, msg",
    UPLOAD_FILE_ALLOWED_TYPES: ["png", "jpeg", "jpg", "tif", "tiff", "pdf", "xlsx", "xls", "doc", "docx", "ppt", "pptx", "txt", "eml", "msg"],
    UPLOAD_FILE_RIWA_GPT_FILE_TYPE_NOT_ALLOWED: "File type not allowed, allowed types: pdf, csv, xlsx, xls, doc, docx, txt",
    UPLOAD_FILE_RIWA_GPT_ALLOWED_TYPES: ["pdf", "csv", "xlsx", "xls", "doc", "docx", "txt"],
    UPLOAD_FILE_MAX_FILES: 4,
    get UPLOAD_FILE_MAX_FILES_EXCEEDED() { return `Maximum ${this.UPLOAD_FILE_MAX_FILES} files allowed per session`; },
    CURRENTLY_UPLOADED_FILE: "Current file: ",
    UPLOAD_FILE_ERROR: "Error uploading file, something went wrong.",
    NEW_VENDOR_CHAT: "New Vendor Chat",
    NEW_IT_CHAT: "New IT Chat",
    CHOOSE_AN_OPTION: "Choose an option",
    NO_OPTIONS_FOUND: "No options found",
    CONFIRM_BUTTON: "Confirm",
    SOMETHING_WENT_WRONG: "Something went wrong.",
    NOTIFICATION_ERROR_UPLOADING: "Error Uploading",
    NOTIFICATION_UPLOADED: "Uploaded",
    N_FILES_UPLOADED: "Files Uploaded",
    UPLOAD_N_FILES_LEFT: "Upload",
    UPLOAD_N_FILES_RIGHT: "Files?",
    LOADING_CHAT: "Initializing Chat",
    SSO_LOADING: "Logging you in",
    ADMIN_SIDEBAR_BUTTON_TOOLTIP: "Admin View",
    T_CODE_REDIRECT_FROM_PATH: "/functions/Internal Control & SOX",
    T_CODE_REDIRECT_TO_PATH: "/tcode-admin-view",
    ADMIN_VIEW_PATH: "/admin-view",
}
export const TYPING_MESSAGES = [
    "Analyzing your request...",
    "Searching through knowledge base...",
    "Preparing your response...",
    "Processing information...",
    "Gathering insights...",
    "Reviewing data...",
    "Organizing thoughts...",
    "Crafting the perfect answer...",
    "Almost ready...",
    "Finalizing response..."
  ];

export const SYNC_MESSAGES = [
    "Uploading your document...",
    "Processing file contents...",
    "Extracting information...",
    "Indexing document data...",
    "Syncing with knowledge base...",
    "Validating document structure...",
    "Preparing document for analysis...",
    "Almost ready for queries...",
    "Finalizing sync...",
    "Document ready!"
  ];

export const POPUP_CONSTANTS = {
    HISTORY_POPUP_RENAME_BUTTON: "Rename",
    HISTORY_POPUP_DELETE_BUTTON: "Delete",
    USER_OPTIONS_POPUP_HOME: "Home",
    USER_OPTIONS_POPUP_SIGNOUT: "Sign Out",
    FEEDBACK_HEADING: "Give us a feedback!",
    FEEDBACK_NEGATIVE: "Extremely Dissatisfied",
    FEEDBACK_POSITIVE: "Extremely Satisfied",
    FEEDBACK_DESCRIPTION_PLACEHOLDER: "Tell us more",
    FEEDBACK_SUBMIT_BUTTON: "Send",
    HELP_SUBMIT_BUTTON: "Send",
    HELP_HEADING: "How can we help you?",
    HELP_TITLE_INPUT_PLACEHOLDER: "Title",
    HELP_DESCRIPTION_INPUT_PLACEHOLDER: "Description",
    HELP_ATTACHMENT_BUTTON_LABEL: "Attachment",
    HELP_ATTACHMENT_BUTTON_TITLE: "Select File",
    HELP_REQUEST_RAISED: "Your request has been raised!",
    HELP_SUCCESS: "Success!",
    HELP_RAISE_ANOTHER: "Raise Another?",
    FEEDBACK_GIVEN: "Thank you for your feedback!",
    FEEDBACK_SUCCESS: "Success!",
    GIVE_ANOTHER_FEEDBACK: "Give Another Feedback?",
    NOT_AUTHORIZED_TO_ACCESS: "You don't have permission to use this feature. If you think this is an error, please contact the administrator.",
    SESSION_EXPIRED: "Your session has expired. To continue our conversation, please log in again. I'm here whenever you're ready!",
    FLOATING_SESSION_EXPIRED: "Your session has expired. To continue our conversation, please log in to the portal again. I'm here whenever you're ready!"
}

export const MOBILE_SIDEBAR_CONSTANTS = {
    BACK_BUTTON: "Back",
    FUNCTIONS_BUTTON: "Functions",
    HISTORY_BUTTON: "History",
    PROFILE_HEADER: "Profile & Settings"
}

export const ERROR_SCREEN_CONSTANTS = {
    NOT_FOUND_ERROR: "Our Apologies, This is, almost certainly, not the page you were looking for.",
    LOGIN_AGAIN_ERROR: "Our Apologies, Something went wrong, please login again",
    ERROR_HOME: "Home",
    ERROR_LOGIN: "Log In",
    FOUR_0_FOUR: "404",
    ERROR_RETRY: "Retry"
}

export const FLOATING_VENDOR_CONSTANTS = {
    REFRESH_BUTTON: "Refresh",
}

export const ENABLE_HTML_TAGES = {ADD_ATTR: ['target']}

export const IDESK_ERROR_MESSAGE = { text: "I didn't understand that. I can help you with the following", sender: "bot", type: "ImageResponseCard", buttons: [
    {
        "text": "View By Ticket Number",
        "value": "View By Ticket Number"
    },
    {
        "text": "View Recent Tickets",
        "value": "View Recent Tickets"
    },
    {
        "text": "Create New Ticket",
        "value": "Create New Ticket"
    }
]}

export const VENDOR_ERROR_MESSAGE = { text: "I didn't understand that. I can help you with the following", sender: "bot", type: "ImageResponseCard", buttons: [
    {
        "text": "Invoice Status",
        "value": "Invoice Status"
    },
    {
        "text": "Payment Advice",
        "value": "Payment Advice"
    },
]}

export const ACE_ERROR_MESSAGE = { text: "I didn't understand that. Please try refreshing the application.", sender: "bot", type: "PlainText"
}
   
export const CODE_OF_CONFLICT_CONSTANTS = ['Yes', 'No', 'Agent', 'Employee', 'Director', 'Proprietor', 'Contractor']

export const CONFLICT_ERROR_MESSAGE = { text: "I didn't understand that. Please try refreshing the application or try to contact the IT Helpdesk.", sender: "bot", type: "PlainText"}


export const TCODE_ADMIN_CONSTANTS = {
    /** Show tcode search box only when user has more than this many tcodes */
    SEARCH_THRESHOLD: 8,
    /** Remarks are mandatory only when the action is rejection; optional for approval */
    REMARKS_REQUIRED_FOR_REJECTION_ONLY: true,
    /** Canonical display order for company tabs */
    COMPANY_ORDER: [
        "AMNS India",
        "AMNS Ports Hazira",
        "AMNS Ports Paradeep",
        "AMNS Ports Vizag",
        "AMNS Shipping",
        "AMNS Power Transmission",
        "AMNS GTC",
    ],
};

export const timeFilterOptions = {
  "7d": "Last 7 Days",
  "15d": "Last 15 Days",
  "30d": "1 Month",
  "90d": "3 Months",
};

export const MARKET_SITE_OPTIONS = [
  { label: "IndiaMART",             value: "indiamart.com"              },
  { label: "TradeIndia",            value: "tradeindia.com"             },
  { label: "Moglix",                value: "moglix.com"                 },
  { label: "IndustryBuying",        value: "industrybuying.com"         },
  { label: "Zetwerk",               value: "zetwerk.com"                },
  { label: "OfBusiness",            value: "ofbusiness.com"             },
  { label: "Alibaba India",         value: "alibaba.com"                },
  { label: "Amazon Business",       value: "business.amazon.in"         },
  { label: "Flipkart Wholesale",    value: "flipkart.com/wholesale"     },
  { label: "ExportersIndia",        value: "exportersindia.com"         },
];

/** Spend Analytics dashboard — spend-by dimension configs */
export const SPEND_BY_DIMENSIONS = [
  { key: "category",  label: "Category",  responseKey: "spend_by_category",  nameField: "MATERIAL_TYPE_DESCRIPTION", spendField: "TOTAL_SPEND" },
  { key: "vendor",    label: "Vendor",    responseKey: "spend_by_vendor",    nameField: "VENDOR_NAME",               spendField: "TOTAL_SPEND" },
  { key: "location",  label: "Location",  responseKey: "spend_by_location",  nameField: "PO_LOCATION",               spendField: "TOTAL_SPEND" },
  { key: "plant",     label: "Plant",     responseKey: "spend_by_plant",     nameField: "PLANT",                     spendField: "TOTAL_SPEND" },
];

/** Material Analysis — spend-by dimension configs */
export const MATERIAL_CHART_DIMENSIONS = [
  { key: "vendor",   label: "Vendor",   groupField: "VENDOR_NAME" },
  { key: "location", label: "Location", groupField: "PO_LOCATION" },
];

/** Material Analysis — shared limits */
export const MAX_MATERIAL_SELECTION = 5;
export const TOP_VENDORS_COUNT     = 5;
export const MAX_CHART_VENDORS     = 5;
export const MAX_CHART_SEGMENTS    = 8;
export const MAX_TREND_MONTHS      = 12;

/** Material Analysis — per-material section accent colors */
export const MATERIAL_SECTION_COLORS = ["#1d4ed8", "#7c3aed", "#0891b2", "#c2410c", "#15803d"];

/** Canonical month ordering — used for chronological sorting */
export const MONTH_ORDER = [
    "JAN", "FEB", "MAR", "APR", "MAY", "JUN",
    "JUL", "AUG", "SEP", "OCT", "NOV", "DEC",
];

/** App-wide brand palette */
export const BRAND_COLOR       = "#680705";
export const BRAND_COLOR_LIGHT = "#fef2f2";

/** LCS Dashboard — period-to-month mappings */
export const LCS_QUARTER_OPTIONS = ["Q1", "Q2", "Q3", "Q4"];
export const LCS_HALF_YEAR_OPTIONS = ["H1", "H2"];

export const LCS_QUARTER_TO_MONTHS = {
    Q1: { start: "JAN", end: "MAR" },
    Q2: { start: "APR", end: "JUN" },
    Q3: { start: "JUL", end: "SEP" },
    Q4: { start: "OCT", end: "DEC" },
};

export const LCS_HALF_TO_MONTHS = {
    H1: { start: "JAN", end: "JUN" },
    H2: { start: "JUL", end: "DEC" },
};

/** LCS Dashboard — metric type toggle options */
export const LCS_METRIC_TYPES = {
    PRODUCTION: "Production Data",
    CONVERSION_COST: "Conversion Cost",
};

/** LCS Dashboard — thickness slab mode options */
export const LCS_SLAB_MODES = {
    OVERVIEW: "All Thickness Slabs (Overview)",
    SPECIFIC: "Filter Specific Thickness Slab",
};

/** LCS Dashboard — groupBy options for production/conversion cost */
export const LCS_GROUP_BY_OPTIONS = [
    { label: "Monthly",     value: "MONTH" },
    { label: "Quarterly",   value: "QUARTER" },
    { label: "Half-Yearly", value: "HALF_YEAR" },
    { label: "Yearly",      value: "YEAR" },
];

/** LCS Dashboard — plant color palette for multi-location charts */
export const PLANT_COLORS = [
    { bg: "rgba(42, 157, 143, 0.75)", border: "#2a9d8f", fill: "rgba(42, 157, 143, 0.08)" },
    { bg: "rgba(230, 57, 70, 0.75)",  border: "#e63946", fill: "rgba(230, 57, 70, 0.08)" },
    { bg: "rgba(69, 123, 157, 0.75)", border: "#457b9d", fill: "rgba(69, 123, 157, 0.08)" },
    { bg: "rgba(244, 162, 97, 0.75)", border: "#f4a261", fill: "rgba(244, 162, 97, 0.08)" },
    { bg: "rgba(38, 70, 83, 0.75)",   border: "#264653", fill: "rgba(38, 70, 83, 0.08)" },
];

// Background gradient blobs component
export const GradientBackground = () => (
  <div className="pointer-events-none absolute inset-0 z-0 overflow-visible">
    <div className="gradient-blob blob-1"></div>
    <div className="gradient-blob blob-2"></div>
    <div className="gradient-blob blob-3"></div>
    <div className="gradient-blob blob-4"></div>
  </div>
);